import React from 'react';
import { Route } from 'react-router-dom';
import CardGridDashboard from '../../HomePage/CardGrid.js';
import Content from '../../HomePage/Content.js';
import SportbotLiteTutorial from '../../HomePage/Tutorial.js';
import SecurityCenter from '../../HomePage/Security.js';
import DisinfectionAnalysis from '../../Analysis/DisinfectionAnalysis.js';
import AnalysisRobotsListScreen from '../../Analysis/AnalysisRobotsListScreen.js';
import AnalysisRobotHistoryScreen from '../../Analysis/AnalysisRobotHistoryScreen.js';

export const homeAndAnalyticsRoutes = [
  <Route key="card" path="/card" element={<CardGridDashboard />} />,
  <Route key="content" path="/content" element={<Content />} />,
  <Route
    key="tutorial-sportbot-lite"
    path="/tutorial"
    element={<SportbotLiteTutorial />}
  />,
  <Route key="security-center" path="/security" element={<SecurityCenter />} />,
  <Route key="disinfection-analysis" path="/disinfection-analysis" element={<DisinfectionAnalysis />} />,
  <Route key="analytics-robots-list" path="/analytics/robots-list" element={<AnalysisRobotsListScreen />} />,
  <Route key="analytics-robot-history" path="/analytics/robot/:robotId/history" element={<AnalysisRobotHistoryScreen />} />,
];
